module.exports = __webpack_public_path__ + "static/media/icon-down.f1d81dcf.svg";